<template>
  <div class="apply">
    <el-card>
      <div class="basic">
        <firstHeading style="margin-bottom: 20px;">基本信息</firstHeading>
        <div class="info">
          <el-form :model="formInline" class="demo-form-inline1">
            <el-form-item label="用电编号：" >
              <el-input style="width: 200px;" v-model="formInline.user" placeholder="转供电主体1号"></el-input>
            </el-form-item>
            <el-form-item label="转供电主体名称：">
              <el-input style="width: 200px;"  v-model="formInline.user" placeholder="转供电主体1号"></el-input>
            </el-form-item>
            <el-form-item label="合同负荷：">
              <el-input style="width: 200px;"  v-model="formInline.user" placeholder="转供电主体1号"></el-input>
            </el-form-item>
            <el-form-item label="供电单位：">
              <el-input style="width: 200px;"  v-model="formInline.user" placeholder="20"></el-input>
            </el-form-item>
            <el-form-item label="响应速度：">
              <el-select style="width: 200px;"  v-model="formInline.region" placeholder="日级">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="ydinfo">
        <firstHeading style="margin-bottom: 20px;">用电信息</firstHeading>
        <div class="info">
          <el-form :model="formInline" class="demo-form-inline1">
            <el-form-item label="用电信息：">
              <el-input  style="width: 200px;" v-model="formInline.user" placeholder="转供电主体1号"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div class="sqinfo">
        <firstHeading style="margin-bottom: 20px;">申请信息</firstHeading>
       <div class="info">
        <el-form :model="formInline" class="demo-form-inline1">
          <el-form-item label="申请时段">
            <el-col :span="24">
              <el-date-picker type="date" placeholder="2021-06-19至2021-06-20" v-model="sizeForm.date1" style="width: 100%;">
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="申请时段负荷(Kw)：">
            <el-input v-model="formInline.user" placeholder="100"></el-input>
          </el-form-item>
        </el-form>
       </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import firstHeading from '@/components/firstHeading.vue';
export default {
  name: "",
  components: {firstHeading},
  data() {
    return {
      formInline: {
        user: "",
        region: "",
      },
      sizeForm: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
    };
  },
};
</script>

<style lang="scss" scoped>
.apply{
  width: 100%;
  .info{
      width: 100%;
      // height: 100px;
      padding: 30px 40px;
      box-sizing: border-box;
      background-color: #f5f7f7;
      .demo-form-inline1{
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        .el-form-item{
          display: flex;
          align-items: center;
          margin-right: 20px;
          // margin: 0;
          // margin-left: 20px;
        }
      }
      
    }
  .ydinfo{
    margin: 20px 0;
  }
}
</style>
